// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Xy5tW","buttonContainer":"styles_buttonContainer__tHLxI","button":"styles_button__G7DG+","titleClassName":"styles_titleClassName__xr5ll"};